import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

function rankStyle(rank) {
  if (rank === 0) return "gold-gradient text-[#1E3A8A]";
  if (rank === 1) return "bg-slate-300 text-slate-800";
  if (rank === 2) return "bg-amber-700 text-white";
  return "bg-secondary text-foreground";
}

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then((r) => setRows(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="leaderboard-page">
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold">Community</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-2">Leaderboard</h1>
      </div>

      <div className="rounded-3xl bg-card border border-border overflow-hidden">
        {rows.map((u, i) => (
          <div key={u.id} className={`flex items-center gap-4 px-5 py-4 border-b border-border last:border-0 ${i < 3 ? "bg-gold/5" : ""}`}>
            <div className={`h-10 w-10 rounded-full flex items-center justify-center font-bold ${rankStyle(i)}`}>
              {i + 1}
            </div>
            <div className="flex-1">
              <p className="font-semibold">{u.name}</p>
              <p className="text-xs text-muted-foreground">{u.email}</p>
            </div>
            <div className="flex items-center gap-1.5 text-gold font-bold">
              <Trophy className="h-4 w-4" /> {u.points}
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="p-8 text-center text-muted-foreground">No students yet.</div>}
      </div>
    </div>
  );
}
